import { streamingRestApi } from '@/service/streamingApi'
import type { ContributionPoint } from '@/types/streams/contributionPoint'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export type ContributionPointsSortAttribute = 'name'
export type ContributionPointsParamName = 'filter'

const fetchContributionPointsApi = async (
  args: FetchApiArgs<undefined, ContributionPointsParamName>
): Promise<FetchApiResponse<ContributionPoint>> => {
  const { filters, signal } = args

  const queryFromFilters = filters?.filter?.[0]?.value?.toString() || undefined

  const data = await streamingRestApi.endpoints.contributionPoints.getContributionPoints(signal)

  return {
    content: data,
    totalElements: data.length,
    query: queryFromFilters
  }
}

export const useContributionPointsStore = createBaseTableStore({
  storeName: 'Contribution Points',
  fetchApi: fetchContributionPointsApi,
  features: {
    pagination: true,
    filtering: true
  }
})
